import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8bcc0d5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "job-wrapper" }
const _hoisted_2 = { class: "mb-4 text-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ps-4" }, " Add one more job", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JobsElement = _resolveComponent("JobsElement")!
  const _component_feather_icon = _resolveComponent("feather-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_JobsElement, {
      jobs: _ctx.computedModel,
      "onUpdate:jobs": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedModel) = $event)),
      onSetSelectedTask: _ctx.setSelectedTask,
      onSetSelectedJob: _ctx.setSelectedJob,
      type: _ctx.type
    }, null, 8, ["jobs", "onSetSelectedTask", "onSetSelectedJob", "type"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "btn btn-light position-relative",
        "data-bs-toggle": "modal",
        "data-bs-target": "#addJobModal",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setSelectedJob({})))
      }, [
        _createVNode(_component_feather_icon, {
          type: "plus-square",
          size: "16",
          class: "position-absolute mt-1"
        }),
        _hoisted_3
      ])
    ])
  ]))
}